function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "22",
  viewBox: "0 0 21 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.664 8.81a2.203 2.203 0 100-4.407 2.203 2.203 0 000 4.407z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.204 0h-1.08v3.733h1.08V0z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.204 9.596h-1.08v3.733h1.08V9.596z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.329 6.124H9.596v1.08h3.733v-1.08z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.733 6.124H0v1.08h3.733v-1.08z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 8.74l-.765.763 1.876 1.876.764-.764L9.499 8.74z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.716 1.954l-.763.764 1.875 1.876.764-.764-1.876-1.876z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.612 1.953L8.736 3.83l.764.764 1.876-1.876-.764-.764z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.827 8.736l-1.875 1.876.763.764L4.591 9.5l-.764-.764z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.81 18.314l-2.616 2.617L8.263 22l2.617-2.617-1.07-1.069z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.587 8.719S9.297 6.846 9.297 19.946l.007.006c13.1 0 11.283-11.233 11.283-11.233zm-9.723 10.466l-.853-.853 6.55-6.55.853.853-6.55 6.55z",
  fill: "#000"
})));